import { IItem, IItemData } from '@/models/item';
import {
  ModuleAccessoryTypeEnum,
  ModulePaymentTypeEnum
} from './module.constant';

export enum ModuleBrands {
  MODULE_BRAND_NONE = 0,
  MODULE_BRAND_JCMI,
  MODULE_BRAND_JAMESWAY,
  MODULE_BRAND_CHICKMASTER,
  MODULE_BRAND_AIRWAY
}

export interface IModulePaymentType {
  value: ModulePaymentTypeEnum;
  display_name: string;

  toString(): string;
}

export interface IModuleAccessoryType {
  value: ModuleAccessoryTypeEnum;
  display_name: string;

  toString(): string;
}

export interface IModuleFieldErrorData {
  id?: string[];
  name?: string[];
  description?: string[];
  image?: string[];
  image_url?: string[];
  is_accessories?: string[];
  is_spare_parts?: string[];
  is_published?: string[];
  is_public?: string[];
  is_subscription?: string[];
  is_archived?: string[];
  has_disclaimer?: string[];
  brand?: string[];
  order?: string[];
  payment_type?: string[];
  accessory_type?: string[];
}

export interface IAccessoryCategoryData {
  id?: number;
  name?: string;
  items?: IItemData[];
}

export interface IAccessoryCategory extends IAccessoryCategoryData {
  name: string;
  items: IItem[];
}
